import {
  IloginResponse,
  ILoginResponseNormalized,
  IMFASessionValidatePayload,
} from "../interfaces/Index";

export const generateAbilityFromScopes = (
  subject: string,
  action: string,
  isSelf: boolean,
  userId: string
) => {
  return isSelf
    ? {
        subject: subject,
        action: action,
        conditions: { userId: userId },
      }
    : {
        subject: subject,
        action: action,
      };
};

export const loginPayloadNormalizer = (
  res: IloginResponse
): ILoginResponseNormalized => {
  return {
    isLoggedIn: true,
    auth: {
      token: res.token || null,
      expiresAt: res.expiresAt || null,
      refreshToken: res.refreshToken || null,
    },
    scopes: res.scopes
      ? res.scopes.map((scope) => {
          const parts = scope.split(".");
          if (scope.includes("*")) {
            return {
              subject: parts[0],
              action: parts[1],
            };
          } else {
            return generateAbilityFromScopes(
              parts[1],
              parts[3],
              parts[2] === "self",
              res.userInfo.id
            );
          }
        })
      : [],
    userInfo: res.userInfo || null,
    roles: res.roles
  };
};

export const loginOIDCPayloadNormalizer = (
  res: IloginResponse
): ILoginResponseNormalized => {
  return {
    isLoggedIn: true,
    auth: {
      token: res.token || null,
      expiresAt: res.expiresAt || null,
      refreshToken: res.refreshToken || null,
    },
    scopes: res.scopes
      ? res.scopes.map((scope) => {
          const parts = scope.split(".");
          if (scope.includes("*")) {
            return {
              subject: parts[0],
              action: parts[1],
            };
          } else {
            return generateAbilityFromScopes(
              parts[1],
              parts[3],
              parts[2] === "self",
              res.userInfo.id
            );
          }
        })
      : [],
    userInfo: res.userInfo || null,
    roles: res.roles,
    isOIDC: true
  };
};

export const normalizedMfaFallbackPayload = (
  factorType: string,
  token: string
 ) => {
  return {
    token: token,
    fallbackFactor: factorType
  }
}

export const normalizeValidateMfaPayload = (
  factorData: string,
  token: string
): IMFASessionValidatePayload => {
  return {
    token: token,
    factorData: factorData,
    clientInfo: {
      androidVersion: "",
      appVersion: "",
      availableRam: "",
      availableStorage: "",
      clientTime: "",
      clientTimeZone: "",
      competitorApps: [],
      deviceBrand: "",
      deviceId: "",
      deviceManufacturer: "",
      deviceModel: "",
      ipAddresses: [],
      isWifiEnabled: "",
      screenDpi: "",
      screenHeight: "",
      screenWidth: "",
      socialMediaApps: [],
      totalRam: "",
      totalStorage: "",
    },
  };
};
